import { Check } from "lucide-react";
import SkeletonCard from "./SkeletonCard";

/**
 * FocusAreaGrid
 * Renders the AI-generated focus area cards grid.
 * Extracted from CustomStep3_FocusAreas to reduce file size.
 */
const FocusAreaGrid = ({
  focusAreas,
  selectedFoci,
  maxAllowed,
  disabled,
  isRegenerating = false,
  onToggle,
}) => (
  <div
    className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3"
    style={{
      gridTemplateRows: "repeat(auto-fit, minmax(120px, 1fr))",
      contain: "layout",
    }}
  >
    {focusAreas.map((area) => {
      const isSelected = selectedFoci.includes(area.title);
      const isDisabled = !isSelected && selectedFoci.length >= maxAllowed;

      // During regen, non-selected cards show as skeletons
      if (isRegenerating && !isSelected) {
        return <SkeletonCard key={area.id} />;
      }

      return (
        <button
          key={area.id}
          type="button"
          onClick={() => !isDisabled && onToggle(area.title)}
          disabled={disabled || isDisabled}
          style={{
            minHeight: "120px",
            transform: "translateZ(0)",
            border:
              "linear-gradient(233.57deg, rgba(217, 217, 217, 0.05) -5.01%, rgba(115, 108, 207, 0.01) 100%)",
          }}
          className={`border rounded-lg dark:text-[#CCCCCC] text-textSecondary p-4 text-left border-gray-700/50 dark:shadow-md shadow-sm ${
            isSelected
              ? "dark:bg-purple-500/20 bg-gray-100 dark:text-white text-textPrimary border-purple-400"
              : isDisabled
              ? "dark:bg-gray-800/40 bg-gray-200 border-gray-600/30 dark:text-gray-500 text-textSecondary cursor-not-allowed opacity-50"
              : "dark:text-[#CCCCCC] text-textPrimary dark:hover:bg-white/20 hover:bg-gray-100 dark:hover:border-white/30 cursor-pointer"
          } transition-colors duration-200 relative group`}
        >
          <div className="flex items-start justify-between mb-3">
            <span className="font-medium text-sm pr-2 line-clamp-2 dark:group-hover:text-white group-hover:text-textSecondary transition-colors">
              {area.title}
            </span>
            {isSelected && (
              <div className="absolute top-2.5 right-2.5 h-6 w-6 rounded-full bg-gradient-to-r from-pink-500 to-blue-500 flex justify-center items-center">
                <Check className="h-4 w-4 text-white" />
              </div>
            )}
          </div>
          <p className="text-xs opacity-75">{area.description}</p>
        </button>
      );
    })}
  </div>
);

export default FocusAreaGrid;
